/**
 * Sessão de aplicativo do CaféGestor Vendedor (A1). Aberta depois do login (Supabase) e da
 * escolha da empresa, por quem tem `app_vendedor.acessar` nessa empresa. O segredo vai só para
 * o aparelho (armazenamento seguro) e viaja no cabeçalho `x-app-session`; o banco guarda o hash.
 *
 * Não é prova de integridade do APK: é uma credencial a mais, ligada ao usuário, à empresa e à
 * sessão de login, com validade e revogação.
 */
import { z } from "zod";

/** Cabeçalho com o segredo da sessão de aplicativo (nunca registrado em log). */
export const APP_SESSION_HEADER = "x-app-session";

/** Prefixo do segredo (identifica o formato; o resto é aleatório). */
export const APP_SESSION_PREFIX = "cgv1.";

/** Validade absoluta da sessão de aplicativo (o banco limita a 31 dias). */
export const APP_SESSION_DAYS = 30;

/** Sessões ativas por usuário e empresa: abrir mais revoga a mais antiga. */
export const APP_SESSION_MAX_ACTIVE = 5;

export const APP_ENVS = ["homologacao", "producao", "desenvolvimento"] as const;
export type AppEnv = (typeof APP_ENVS)[number];

export const appSessionCreateSchema = z
  .object({
    clientPlatform: z.enum(["android", "web_dev"]),
    appVersion: z
      .string()
      .trim()
      .regex(/^[0-9A-Za-z.+_-]{1,40}$/, "Versão do aplicativo inválida."),
    appEnv: z.enum(APP_ENVS),
  })
  .strict();
export type AppSessionCreateInput = z.input<typeof appSessionCreateSchema>;

/** Resposta da abertura: o segredo aparece UMA vez (só o aparelho o guarda). */
export type AppSessionCreated = {
  sessionId: string;
  secret: string;
  expiresAt: string;
};

/** Situação da sessão de aplicativo em uso (rota protegida por ela). */
export type AppSessionStatus = {
  sessionId: string;
  companyId: string;
  userId: string;
  createdAt: string;
  expiresAt: string;
  appVersion: string;
  appEnv: AppEnv;
};
